import { useContext } from "react";
import { AppContext } from "../context/AppData/provider";

export const useAppContext = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error("useAppContext must be used within an AppData provider");
  }

  const { actions, dispatch, selectors } = context;

  return {
    actions,
    dispatch,
    selectors,
  };
};
